import { combineReducers, createStore } from "redux";
import userData from "./reducers/userData";
import workplace from "./reducers/workplace";

export default createStore(combineReducers({ userData: userData, workplace: workplace }));